import { DataBean } from "../DataBean";

export class Disclaimer extends DataBean {
  public async updateDisclaimer(bean: any): Promise<any> {
    return this.getCustomService(
      "TemplateERP",
      "com.advantage.templates.bean.Disclaimer_updateDisclaimer_com.advantage.templates.bean.Disclaimer",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.advantage.templates.bean.Disclaimer",
        },
      ]
    );
  }

  public async getDisclaimerCatalogPorPropiedades(
    properties: any,
    maxRows: number
  ): Promise<any> {
    return this.getCustomService(
      "TemplateERP",
      "java.util.List_getDisclaimerCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteDisclaimer(iddisclaimer: number): Promise<any> {
    return this.getCustomService(
      "TemplateERP",
      "boolean_deleteDisclaimer_Number",
      [iddisclaimer]
    );
  }
}
